import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
    CommonLoader,
    CommonPopup,
    CommonQuesProgress,
    QuesLoader,
    QuestionCommonPopup,
    useScreenTransition,
    useTimer,
    redirectToAssessmentSummary,
    useTimerValues,
} from "../../util/common";
import { TEST_COMPLETE, TEST_QUESTIONS } from "../../util/constants";
import {
    getNoCacheCall,
    postCall,
    getNumberOfQuestionAnswered,
} from "../../util/resources";
import SesHeader from "../header";

import { ProgressBar } from "@adeccoux/tag-ds";
import { BaseContext } from "../../App";
import WarmupComplete from "../instructions/warmupComplete";

const TestTaker = () => {
    const [test, setTest] = useState();
    const [questionImage, setQuestionImage] = useState();
    const { isWarmupDoneShown, setWarmupDoneShown } = useContext(BaseContext);
    const { phase, loading, startTransition, done } = useScreenTransition();

    const [selectedAns, setSelectedAns] = useState(-1);
    const [popupData, setpopupData] = useState({
        isOpen: false,
        popupHeader: "",
        popupBody: "",
        popupFooter: "",
    });
    const [qpopupData, setQpopupData] = useState({
        isOpen: false,
        popupHeader: "",
        popupBody: "",
        popupFooter: "",
    });
    const { min, sec, totalSecLeft, startTimer, stopTimer } = useTimer();
    const exampleTest = useRef();
    const qattempts = useRef(0);
    const location = useLocation();
    const phrases = location.state.user.siteConfig.phrases;
    const navigate = useNavigate();
    const formRef = useRef();
    const quesNo = useRef(-1);
    const attachKeyListenRef = useRef();
    const keyMappings = useRef({});
    const header = useRef({
        "x-xpert-session": location.state.user.sessionId,
        "Content-Type": "application/json",
    });
    const assessmentTimerStarted = useRef(false);
    const stepRef = useRef();
    const correctExample = useRef();
    const { timerPerQuestion } = useTimerValues();

    const changeSelectedAns = (e) => {
        setSelectedAns(e.target.value);
        setExampleAns(e.target.value);
    };

    const setExampleAns = (selectedAns) => {
        if (location.state.warmUp && quesNo.current !== -1) {
            let quesObj =
                location.state.test.testExample[quesNo.current - 1]?.questions;
            const ansObj = {
                answers: [],
                structure: null,
                value: selectedAns,
            };
            quesObj[0].userAnswer = ansObj;
        }
    };

    const detectKeyDown = (e) => {
        e.preventDefault();
        if (!loading) {
            if (e.code in keyMappings.current) {
                setSelectedAns(keyMappings.current[e.code]);
                setExampleAns(keyMappings.current[e.code]);
            }
            if (selectedAns !== -1 && e.code === "Space") {
                if (qpopupData.isOpen) {
                    qclosePopUp();
                } else {
                    nextNavigate();
                }
            }
        }
    };

    const validateAnsw = async (selectedAns, question) => {
        let currectAns;
        let currectAnsVal;
        for (let i = 0; i < 4; i++) {
            if (question.questions[0].answers[i].score == 1) {
                currectAns = i;
                currectAnsVal = question.questions[0].answers[i].content;
            }
        }
        if (correctExample.current) {
            startTransition(async () => {
                correctExample.current = false;
                if (test.lastPage) {
                    stopTimer();
                    navigate("", {
                        state: {
                            ...location.state,
                            warmUp: false,
                            samplesCompleted: true,
                        },
                    });
                    setWarmupDoneShown(true);
                } else {
                    qattempts.current = 0;
                    await getQuestion();
                }
                done();
            });
        } else {
            let message;
            if (selectedAns == currectAns) {
                correctExample.current = true;
                message = phrases?.["15145"];
                if (test.lastPage) {
                    navigate("", {
                        state: {
                            ...location.state,
                            samplesCompleted: true,
                        },
                    });
                }
            } else {
                switch (qattempts.current) {
                    case 0:
                        message = phrases?.["15146"];
                        qattempts.current = qattempts.current + 1;
                        break;
                    case 1:
                        message = phrases?.["15147"];
                        qattempts.current = qattempts.current + 1;
                        break;

                    default:
                        message =
                            phrases?.["15148"] +
                            "<br>" +
                            currectAnsVal +
                            phrases?.["15149"];
                        message = String(message);
                        qattempts.current = qattempts.current + 1;
                        break;
                }
            }
            message = message.split("\\n").join("<br />");
            message =
                `<span style="font-size: medium;vertical-align: text-top;padding-right: 5px;" class="material-icons ${
                    correctExample.current ? "icon-success" : "icon-error"
                }">${correctExample.current ? "check_circle" : "info"}</span>` +
                message;
            setQpopupData((prev) => {
                prev = {
                    ...prev,
                    isOpen: true,
                    popupHeader: phrases?.["10980"],
                    popupBody: message,
                    popupFooter: phrases?.["10928"],
                };
                return prev;
            });
        }
    };

    const nextNavigate = async () => {
        if (location.state.warmUp) {
            await validateAnsw(
                selectedAns,
                exampleTest.current[quesNo.current - 1]
            );
        } else {
            startTransition(async () => {
                const elapsedTime = stopTimer();
                const ansObj = {
                    answers: [],
                    structure: null,
                    value: selectedAns,
                };
                let quesObj = test.questions;
                quesObj[0].userAnswer = ansObj;
                const otherData = {
                    duration:
                        location.state.test.timeByQuestion &&
                        location.state.test.bShowTimer
                            ? elapsedTime
                            : location.state.test.duration + elapsedTime,
                };
                if (
                    location.state.test.timeByQuestion &&
                    location.state.test.bShowTimer
                ) {
                    quesObj[0].duration = elapsedTime;
                }
                try {
                    let response;
                    if (test.lastPage) {
                        stopTimer();
                        response = await postCall(
                            TEST_COMPLETE + location.state.test.id,
                            { ...otherData, questions: quesObj },
                            header.current
                        );
                        redirectToAssessmentSummary(location, navigate);
                    } else {
                        response = await postCall(
                            TEST_QUESTIONS + location.state.test.id,
                            { ...otherData, questions: quesObj },
                            header.current
                        );
                    }
                    if (response.data.status === true) {
                        if (test.lastPage) {
                            redirectToAssessmentSummary(location, navigate);
                        } else {
                            setSelectedAns(-1);
                            formRef.current.reset();
                            quesNo.current += 1;
                            await getQuestion();
                        }
                    }
                } catch (error) {
                    console.log(error);
                }
                done();
            });
        }
    };

    const getQuestion = async (warmUpChange = false) => {
        if (location.state.warmUp && !warmUpChange) {
            let key;
            keyMappings.current = {};
            exampleTest.current[quesNo.current].questions[0].answers.map(
                (val) => {
                    key = `Digit${val.position + 1}`;
                    keyMappings.current = {
                        ...keyMappings.current,
                        [key]: val.position,
                    };
                }
            );
            setTest(exampleTest.current[quesNo.current]);
            if (
                exampleTest.current[quesNo.current].questions[0]?.userAnswer !==
                null
            ) {
                setSelectedAns(
                    exampleTest.current[quesNo.current].questions[0]?.userAnswer
                        ?.value
                );
            } else {
                setSelectedAns(-1);
            }
            setQuestionImage(
                exampleTest.current[quesNo.current].questions[0].questionImage
            );
            quesNo.current += 1;
        } else {
            try {
                const response = await getNoCacheCall(
                    TEST_QUESTIONS +
                        location.state.test.id +
                        "/" +
                        quesNo.current,
                    header.current
                );
                setTest(response.data[0]);
                quesNo.current = response.data[0].startNumber;
                let key;
                keyMappings.current = {};
                response.data[0].questions[0].answers.map((val) => {
                    key = `Digit${val.position + 1}`;
                    keyMappings.current = {
                        ...keyMappings.current,
                        [key]: val.position,
                    };
                });

                setQuestionImage(response.data[0].questions[0].questionImage);
                let dcTime = atob(response.data[0].questions[0].encTmLmt);
                let dcTimeFi = dcTime.split(":");

                if (
                    location.state.test.timeByQuestion &&
                    location.state.test.bShowTimer
                ) {
                    startTimer(parseInt(dcTimeFi[1], 10), "timeByQuestion");
                } else if (
                    location.state.test.bShowTimer &&
                    location.state.test.timeLimit &&
                    !assessmentTimerStarted.current
                ) {
                    const timeLimit = atob(location.state.test.encTmLmt).split(
                        ":"
                    )[1];
                    assessmentTimerStarted.current = timeLimit;
                    startTimer(timeLimit - location.state.test.duration);
                } else {
                    startTimer();
                }
            } catch (error) {
                console.log();
            }
        }
    };

    const exitTest = () => {
        if (location.state.warmUp) {
            navigate("/instructions", {
                state: { ...location.state, warmUp: false },
            });
        } else {
            setpopupData((prev) => {
                prev = {
                    ...prev,
                    isOpen: true,
                    popupHeader: location.state.test.name,
                    popupBody: phrases?.["1002189"],
                    popupFooter: phrases?.["14392"],
                };
                return prev;
            });
        }
    };

    const buildMediaUrl = (file) => {
        let builtUrl =
            window.location.protocol +
            "//" +
            window.location.hostname +
            "/static";
        builtUrl += (file.startsWith("/") ? "" : "/") + file;
        return builtUrl;
    };

    const closePopUp = () => {
        setpopupData((prev) => {
            prev = { ...prev, isOpen: false };
            return prev;
        });

        stopTimer();
        navigate("/");
    };

    const qclosePopUp = () => {
        setQpopupData((prev) => {
            prev = { ...prev, isOpen: false };
            return prev;
        });
    };

    useEffect(() => {
        if (totalSecLeft === 0) {
            nextNavigate();
        }
        if (assessmentTimerStarted.current) {
            stepRef.current.children[1].children[0].setAttribute(
                "data-secLeft",
                `${min}:${sec}`
            );
        }
    }, [totalSecLeft]);

    const approveAction = () => {
        stopTimer();
        test.lastPage = true;
        nextNavigate();
    };

    const qapproveAction = () => {
        setQpopupData((prev) => {
            prev = { ...prev, isOpen: false };
            return prev;
        });
    };

    const backtoInst = () => {
        navigate("/instructions", {
            state: { ...location.state },
        });
    };

    const handleMainTestStart = () => {
        quesNo.current = -1;
        setSelectedAns(-1);
        getQuestion(true);
    };

    useEffect(() => {
        attachKeyListenRef.current?.focus({
            preventScroll: true,
        });
    }, [test]);

    useEffect(() => {
        if (location.state.warmUp) {
            exampleTest.current = location.state.test.testExample;
            quesNo.current = 0;
        }
        getQuestion();
    }, []);

    if (!test) {
        return <CommonLoader />;
    }

    if (isWarmupDoneShown) {
        return (
            <WarmupComplete
                backtoInst={backtoInst}
                handleMainTestStart={handleMainTestStart}
            />
        );
    }

    return (
        <>
            <div
                className="g-container flex_col p4 g5 pt0_mobile g2_mobile full-width"
                ref={attachKeyListenRef}
                tabIndex="-1"
                onKeyDown={detectKeyDown}
                onBlur={(e) =>
                    e.target.focus({
                        preventScroll: true,
                    })
                }
                style={{ outline: "none" }}
            >
                <SesHeader clientCobranding={location.state.cobrandingLink} />
                <div
                    ref={stepRef}
                    className="top-progress-container flex_row sticky full-width g3 bg01"
                >
                    <CommonQuesProgress test={test} />
                    {!location.state.warmUp &&
                    location.state.test.bShowTimer &&
                    location.state.test.timeLimit ? (
                        <ProgressBar
                            circular
                            step={totalSecLeft}
                            steps={assessmentTimerStarted.current}
                        />
                    ) : (
                        <></>
                    )}
                </div>
                <div className="flex_col g2">
                    <h3>
                        {location.state.warmUp
                            ? location.state.test.testExampleName
                            : location.state.test.name}
                    </h3>
                    <div
                        className="base questionText"
                        dangerouslySetInnerHTML={{
                            __html: test.questions[0].topicInstruction,
                        }}
                    />
                </div>
                <form
                    ref={formRef}
                    className="flex_row flex_col_mobile g2 position_relative"
                >
                    <QuesLoader show={phase === "showing-loader"} />
                    <div className={`flex_col flex_gsb g2 shown ${phase}`}>
                        <div className="small-title">
                            {phrases?.["13106"]} {test.startNumber}
                        </div>
                        {questionImage && (
                            <div className="base p4 roundness_1 border_tt82 full-height">
                                {" "}
                                <img
                                    src={buildMediaUrl(questionImage)}
                                    alt="question-image"
                                    className="ques-img"
                                />
                                <div
                                    className="questionText"
                                    dangerouslySetInnerHTML={{
                                        __html: test.questions[0].questionText,
                                    }}
                                />
                            </div>
                        )}
                        {!questionImage && (
                            <div
                                className="base p4 roundness_1 border_tt82 full-height"
                                dangerouslySetInnerHTML={{
                                    __html: test.questions[0].questionText,
                                }}
                            />
                        )}
                    </div>
                    <div className={`flex_col flex_gsb g2 shown ${phase}`}>
                        <div className="flex_row justify-content_between">
                            <div className="small-title">
                                {phrases?.["15138"]}
                            </div>
                            {!location.state.warmUp &&
                                location.state.test.timeByQuestion &&
                                location.state.test.bShowTimer && (
                                    <div
                                        className={`tag-ds ${
                                            timerPerQuestion > 0 &&
                                            timerPerQuestion < totalSecLeft
                                                ? "status-tag_info"
                                                : "status-tag_error"
                                        }`}
                                    >
                                        <span className="material-icons-outlined icon-order">
                                            timer
                                        </span>
                                        {min}:{sec}
                                    </div>
                                )}
                        </div>
                        <fieldset
                            aria-label="group-container"
                            className="radio-group-container"
                        >
                            <div className="radio-group base p4 roundness_1 border_tt82 full-height">
                                {test.questions[0].answers.map((val, ind) => (
                                    <div
                                        key={test.startNumber + ind}
                                        className="radio-container"
                                    >
                                        <input
                                            id={`option-${ind}`}
                                            type="radio"
                                            name="tt82_options"
                                            value={val.position}
                                            onChange={changeSelectedAns}
                                            checked={
                                                selectedAns == val.position
                                            }
                                        />
                                        <label
                                            dangerouslySetInnerHTML={{
                                                __html: val.content,
                                            }}
                                            htmlFor={`option-${ind}`}
                                        />
                                    </div>
                                ))}
                            </div>
                        </fieldset>
                    </div>
                </form>
                <hr />
                <div className="flex_col_reverse_mobile flex_row align-items_center justify-content_between g2">
                    {test.lastPage && !location.state.warmUp ? (
                        <div />
                    ) : (
                        <button
                            className="button-secondary text_uppercase full-width_mobile"
                            onClick={exitTest}
                            disabled={loading}
                        >
                            {location.state.warmUp
                                ? phrases?.["1000229"]
                                : phrases?.["1002190"]}
                        </button>
                    )}
                    <button
                        className="button-primary text_uppercase full-width_mobile"
                        disabled={selectedAns === -1 || loading}
                        onClick={nextNavigate}
                    >
                        {test.lastPage
                            ? location.state.warmUp
                                ? correctExample.current
                                    ? phrases?.["1000252"]
                                    : phrases?.["10976"]
                                : phrases?.["15140"]
                            : phrases?.["10976"]}
                    </button>
                </div>
            </div>
            <CommonPopup
                popupData={popupData}
                closeAction={closePopUp}
                approveAction={approveAction}
                setterFun={setpopupData}
            />
            <QuestionCommonPopup
                popupData={qpopupData}
                closeAction={qclosePopUp}
                approveAction={qapproveAction}
            />
        </>
    );
};

export default TestTaker;
